import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import { View } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';
import BaseModal from '../../base-modal/BaseModal';
import { DynamicModalProps } from '../DynamicModal.types';

export const ModalUnderMinLimitProducts = observer(
  ({
    type,
    dynamicModalVisible,
    dynamicModalLayer: { id, productLimit, onPressAddBox, onPressRemoveProduct, groupWithLimit },
  }: DynamicModalProps) => {
    const {
      i18n,
      dynamicModal: { closeModal },
    } = useStore();

    return (
      <BaseModal
        testID={TestIDs.BELOW_LIMIT_PRODUCTS}
        modalWidth={386}
        closeOnClickOutside={false}
        modalIcon={
          <View style={{ width: 100, height: 100 }}>
            <Illustration name={ILLUSTRATION_NAMES.AddPhoto} />
          </View>
        }
        title={i18n.t('modal-below-limit-products:title', { limit: productLimit })}
        description={i18n.t(`modal-below-limit-products:description_${groupWithLimit}`)}
        discardText={i18n.t('modal-below-limit-products:close')}
        confirmText={i18n.t('modal-below-limit-products:cta')}
        handleDiscard={onPressRemoveProduct}
        handleConfirm={onPressAddBox}
        onClose={() => (onPressRemoveProduct ? onPressRemoveProduct() : closeModal())}
        isVisible={dynamicModalVisible}
        type={type}
        id={id}
      />
    );
  },
);
